import { get } from 'lodash'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import DefaultLogo from '../../asserts/icon/ic_dlc_logo.svg'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const DEFAULT_HEIGHT = 32
const MAX_HEIGHT = 42
const ASPECT_RATIO = 2.5

const getImageHeight = async (src) => {
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => {
      const { width, height } = img
      const imgHeight = width / height >= ASPECT_RATIO ? DEFAULT_HEIGHT : MAX_HEIGHT
      resolve(imgHeight)
    }
    img.src = src
  })
}

export default function Logo(props) {
  const [height, setHeight] = useState(DEFAULT_HEIGHT)

  const user = useSelector((state) => state.account.user)

  const updateImageHeight = useCallback(async (src) => {
    const height = await getImageHeight(src)
    setHeight(height)
  }, [])

  const imageSrc = useMemo(() => get(user, 'facility.logo.oss_url'), [user])

  useEffect(() => {
    if (imageSrc) {
      updateImageHeight(imageSrc)
    }
  }, [imageSrc])

  return (
    <Container {...props}>
      <img src={imageSrc || DefaultLogo} style={{ margin: 0, width: 'auto', height }} alt='Logo' />
    </Container>
  )
}
